/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import convert from "convert-units";
import _ from "lodash";
import { reactSelectCustomStyle } from "helper";

const UnitConverter = ({ unitOptions, onChange, to }) => {
  const [options, setOptions] = useState([]);
  const [inputData, setInputValue] = useState({
    toValue: 0,
    unit: "",
    value: "",
  });

  useEffect(() => {
    const x = convert().list(unitOptions);
    setOptions(
      x.map((item) => ({
        value: `${_.get(item, "abbr")}`,
        label: _.get(item, "singular"),
      }))
    );
  }, [unitOptions]);

  const onChangeSelect = (name) => (data) => {
    setInputValue({
      ...inputData,
      [name]: _.get(data, "value"),
    });
  };

  // const onChangeInput = e => {
  //   setInputValue({
  //     ...inputData,
  //     [_.get(e, 'target.name')]: _.get(e, 'target.value')
  //   })
  // }

  const onChangeDecimal = (e) => {
    if (e.target.value && /^\d{1,}(\.\d{0,4})?$/.test(e.target.value)) {
      setInputValue({
        ...inputData,
        [_.get(e, "target.name")]: _.get(e, "target.value"),
      });
    }

    if (!e.target.value) {
      setInputValue({
        ...inputData,
        [_.get(e, "target.name")]: "",
      });
    }
  };

  const onBlurDecimal = (e) => {
    setInputValue({
      ...inputData,
      [_.get(e, "target.name")]: parseFloat(_.get(e, "target.value")),
    });
  };

  useEffect(() => {}, [_.get(inputData, "unit")]);

  useEffect(() => {
    if (
      typeof +_.get(inputData, "value") === "number" &&
      !_.isEmpty(_.get(inputData, "unit"))
    ) {
      const toValue = parseFloat(
        convert(_.get(inputData, "value"))
          .from(_.get(inputData, "unit"))
          .to(to)
      ).toFixed(2);
      setInputValue({
        ...inputData,
        toValue,
      });
      return onChange(toValue);
    }
    setInputValue({
      ...inputData,
      toValue: 0,
    });
    return onChange(0);
  }, [_.get(inputData, "value"), _.get(inputData, "unit")]);

  const toLabel = options.find((item) => _.get(item, "value") === to) || {};

  return (
    <div className='form-wrapper p-3 border-0'>
      <div className='full-group'>
        <div className='form-row'>
          <div className='form-input-group col-12 col-md-12'>
            <label htmlFor='last_name' className='full-label mb-0'>
              Convert from
            </label>
            <Select
              styles={reactSelectCustomStyle}
              value={
                options.find(
                  (item) => _.get(item, "value") === _.get(inputData, "unit")
                ) || ""
              }
              options={options}
              onChange={onChangeSelect("unit")}
              components={{
                IndicatorSeparator: () => null,
              }}
            />
          </div>
          <div className='form-input-group col-12 col-md-12'>
            <label htmlFor='middle_name' className='full-label mb-0'>
              Your Value
            </label>
            <input
              disabled={_.isEmpty(_.get(inputData, "unit"))}
              autoComplete='none'
              placeholder='0.00'
              className='full-input text-uppercase'
              type='text'
              step='0.01'
              name='value'
              value={_.get(inputData, "value") || ""}
              onChange={onChangeDecimal}
              onBlur={onBlurDecimal}
            />
          </div>
          <div className='form-input-group col-12 col-md-12'>
            <label htmlFor='middle_name' className='full-label mb-0'>
              to {_.get(toLabel, "label")}
            </label>
            <span className='full-input text-uppercase'>
              {_.get(inputData, "toValue") === "NaN"
                ? 0.0
                : _.get(inputData, "toValue")}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

UnitConverter.propTypes = {
  unitOptions: PropTypes.string.isRequired,
  onChange: PropTypes.instanceOf(Function).isRequired,
  to: PropTypes.string.isRequired,
};

export default UnitConverter;
